import interceptors from "./interceptors/index";

const createReport = (data) => {
  return interceptors({
    url: "/documents/report",
    method: "POST",
    data
  });
};


export { createReport };
